// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import TreeSurgeonPage from "../pages/TreeSurgeon/TreeSurgeon";
const __wvcRoutePaths = ["/TreeSurgeonPage", "/tree-surgeon"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["block-paving", "blockpavingpage", "chimneys", "chimneyspage", "driveway-services", "drivewayservicespage", "fascias-guttering-services", "fasciasgutteringservicespage", "fencing", "fencingpage", "flat-roofs", "flatroofspage", "get-in-touch", "getintouchpage", "home", "homepage", "new-roofs", "newroofspage", "our-craft", "ourcraftpage", "patios", "patiospage", "post", "power-washing", "powerwashingpage", "premium-landscaping-services", "premiumlandscapingservicespage", "privacy-policy", "privacypolicypage", "repointing", "repointingservicespage", "resinbound", "resinboundpage", "roof-cleaning", "roofcleaningpage", "roofing-services", "roofingservicespage", "services-hub", "serviceshubpage", "tarmac-services", "tarmacservicespage", "terms-of-service", "termsofservicepage", "tree-surgeon", "treesurgeonpage", "turfing-artificial-grass-services", "turfingartificialgrassservicespage", "wall-cleaning-services", "wallcleaningservicespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<TreeSurgeonPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<TreeSurgeonPage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
